var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{staticStyle:{"border-right":"1px solid"},attrs:{"clipped":true,"absolute":false,"app":""},on:{"input":_vm.updateDrawer},model:{value:(_vm.drawerLocal),callback:function ($$v) {_vm.drawerLocal=$$v},expression:"drawerLocal"}},[_c('sidebar-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }